import React from 'react';
import { CompactCountdown } from './ui/CompactCountdown';
import { PricingChoice } from './ui/PricingChoice';
import { FadeIn } from './ui/FadeIn';
export function FinalCTA() {
  return <section className="py-10 md:py-24 relative overflow-hidden" data-id="element-78">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-brand-orange/10 via-brand-dark to-brand-dark pointer-events-none" data-id="element-79" />

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-80">
        <FadeIn className="bg-brand-card border border-brand-border rounded-3xl p-4 md:p-8" data-id="element-81">
          <div className="text-center mb-5 md:mb-6" data-id="element-82">
            <h3 className="text-2xl md:text-4xl mb-2" data-id="element-83">
              No dejes pasar esta oportunidad
            </h3>
            <p className="text-xs md:text-sm text-brand-muted uppercase tracking-widest" data-id="element-84">
              Termina en
            </p>
          </div>

          <div className="flex justify-center mb-5 md:mb-6" data-id="element-85">
            <CompactCountdown data-id="element-86" />
          </div>

          <PricingChoice data-id="element-87" />
        </FadeIn>
      </div>
    </section>;
}